'use client';

import cn from 'classnames';
import type { ReactElement } from 'react';
import { useToggle } from 'react-use';
import { Collapse } from 'transitions-kit';
import css from './fold.module.scss';

type Props = {
    children: ReactElement;
};
export function Fold({ children }: Props) {
    const [open, toggle] = useToggle(false);

    return (
        <div className={css.devtool}>
            <Collapse in={open} mountOnEnter unmountOnExit>
                {children}
            </Collapse>
            <button
                type="button"
                className={cn(css.icon, { [css.open]: open })}
                onClick={toggle}
            >
                <span>⚙︎</span>
            </button>
        </div>
    );
}
